document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('a[href]');
  const currentHost = window.location.hostname;

  links.forEach(link => {
    const href = link.getAttribute('href');
    // Ignore internal links, anchor jumps, phone/mailto links, etc.
    if (
      href &&
      !href.startsWith('#') &&
      !href.startsWith('/') &&
      !href.startsWith('mailto:') &&
      !href.startsWith('tel:') &&
      !href.includes(currentHost)
    ) {
      link.setAttribute('rel', 'nofollow noopener noreferrer');
    }
  });
});
